import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'
import { checkStoredBattleModeEnabled, getRequestParams } from './helpers/available_units'

import SOUNDS from 'sounds'
import { updatePlayersMatching } from './players_matching'
import { sortBattleModeSettings } from '../../containers/BattleRooms/components/BattleModeFilter/helpers'

export const AVAILABLE_UNITS_REQUEST = 'available_units/REQUEST'
export const AVAILABLE_UNITS_SUCCESS = 'available_units/SUCCESS'
export const AVAILABLE_UNITS_ERROR = 'available_units/ERROR'
export const AVAILABLE_UNITS_SET_FILTER = 'available_units/SET_FILTER'
export const AVAILABLE_UNITS_SET_SORT = 'available_units/SET_SORT'
export const AVAILABLE_UNITS_SELECT_UNIT = 'available_units/SELECT_UNIT'
export const UNIT_STATE_REACTIVE_UPDATE = 'UNIT_STATE_REACTIVE_UPDATE'
export const UNIT_STATE_REACTIVE_OPEN_TOGGLE = 'UNIT_STATE_REACTIVE_OPEN_TOGGLE'

export function setSort(sort) {
    return {
        type: AVAILABLE_UNITS_SET_SORT,
        payload: { sort },
        meta: {
            webToClient: {
                handler: 'playSound',
                params: {
                    soundId: SOUNDS.CLICK,
                },
            },
        },
    }
}

export function changeSort(prop) {
    return (dispatch, getState) => {
        let order
        const previousSort = getState().availableUnits.sort

        if (prop === null) {
            order = null
        } else if (previousSort.prop !== prop) {
            order = 'desc'
        } else {
            order = (previousSort.order === 'asc' ? 'desc' : 'asc')
        }

        dispatch(setSort({ prop, order }))
        return dispatch(requestAvailableUnits({ showLoader: false }))
    }
}

export const selectUnit = unitData => ({
    type: AVAILABLE_UNITS_SELECT_UNIT,
    payload: {
        unitId: unitData ? unitData.id : null,
    },
})

export function startRequest(showLoader = true) {
    return {
        type: AVAILABLE_UNITS_REQUEST,
        payload: {
            showLoader,
        },
    }
}

export function requestSuccess(response) {
    return dispatch => {
        const playersMatchingSection = response.account_info.players_matching
        if (playersMatchingSection && playersMatchingSection.sortie_settings.length) {
            dispatch(updatePlayersMatching(playersMatchingSection))
        }

        return dispatch({
            type: AVAILABLE_UNITS_SUCCESS,
            payload: {
                units: response.data,
                meta: response.meta,
                account_info: response.account_info,
            },
        })
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: AVAILABLE_UNITS_ERROR,
        payload: errorData,
    }
}

export function requestAvailableUnits({ showLoader, checkLoadingState = true } = { checkLoadingState: true }) {
    return async (dispatch, getState) => {
        const currentState = getState().availableUnits
        if (checkLoadingState && currentState.loading ) return

        dispatch(startRequest(showLoader))
        try {
            const params = getRequestParams(currentState.filter, currentState.sort)
            const response = await httpRequest(`/game_api/available_units${params}`)

            if (!checkStoredBattleModeEnabled(response.meta.battle_modes_settings, currentState.filter)) {
                const newFilter = { ...currentState.filter }
                const sortedBattleModeSettings = sortBattleModeSettings(response.meta.battle_modes_settings)
                if (sortedBattleModeSettings){
                    newFilter.unitType = sortedBattleModeSettings[0].unit_type
                    newFilter.level = sortedBattleModeSettings[0].max_vehicle_level
                } else {
                    newFilter.level = null
                    newFilter.unitType = null
                }
                dispatch(setUnitsFilter(newFilter))
                dispatch({
                    type: AVAILABLE_UNITS_SET_FILTER,
                    payload: { filter: newFilter },
                })
                dispatch(requestAvailableUnits({ showLoader, checkLoadingState: false }))
                return
            }

            const units = response.data

            if (units.length) {
                const { selectedUnitId } = currentState
                const selectedUnit = selectedUnitId &&
                    units.find(unit => unit.id === selectedUnitId)

                dispatch(selectUnit(selectedUnit || units[0]))
            } else {
                dispatch(selectUnit(null))
            }
            dispatch(requestSuccess(response))

        } catch (errorData) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request available units', errorData)
            dispatch(requestError(errorData))
        }
    }
}

export function setUnitsFilter(filter) {
    return {
        type: AVAILABLE_UNITS_SET_FILTER,
        payload: { filter },
    }
}

/** filter units by exact unit type and level. level might be undefined for fort_battles */
export function filterUnitsByLevelAndUnitType(unitType, level) {
    return (dispatch, getState) => {
        const currentState = getState().availableUnits
        if (currentState.loading) return null

        const filter = {
            ...currentState.filter,
            unitType,
            level,
        }

        dispatch(setUnitsFilter(filter))
        return dispatch(requestAvailableUnits({ filter, showLoader: false }))
    }
}

export function filterByHasFreeSlots() {
    return (dispatch, getState) => {
        const currentState = getState().availableUnits
        if (currentState.loading) return null

        let { filter } = currentState
        const hasFreeSlots = !filter.hasFreeSlots
        filter = {
            ...filter,
            hasFreeSlots,
        }

        dispatch(setUnitsFilter(filter))
        return dispatch(requestAvailableUnits({ filter, showLoader: false }))
    }
}

export function filterByWaitingForPlayers() {
    return (dispatch, getState) => {
        const currentState = getState().availableUnits

        if (currentState.loading) return null

        let { filter } = currentState
        const waitingForPlayers = !filter.waitingForPlayers
        filter = {
            ...filter,
            waitingForPlayers,
        }

        dispatch(setUnitsFilter(filter))
        return dispatch(requestAvailableUnits({ filter, showLoader: false }))
    }
}



// WEBPACK FOOTER //
// ./state/actions/available_units.js